import React from 'react';
import p from '../../styles/renewal/OnePage.module.css';
import { USE_CASES } from './data';

const UseCases = () => (
  <section className={`${p.section} ${p.sectionWide} ${p.reveal}`}>
    <div className={p.headCenter}>
      <div className={p.badge}>USE CASES</div>
      <h2 className={p.title}>
        이번 거래에 BNPL 이용이
        <br />
        가능한지 확인해보세요.
      </h2>
      <p className={p.lead}>
        이용방식을 미리 정하지 않아도 됩니다. 거래내용을 확인한 후 가능한 방식과 조건을 안내해
        드립니다.
      </p>
    </div>

    <div className={p.grid4}>
      {USE_CASES.map((item) => (
        <div className={`${p.card} ${p.useCard}`} key={item.no}>
          <div className={p.numSq}>{item.no}</div>
          <h3 className={p.cardTitle}>{item.title}</h3>
          <p className={p.cardText}>{item.body}</p>
          <div className={p.hint}>
            <strong className={p.em}>이런 사업자에게 추천</strong>
            <br />
            {item.target}
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default UseCases;
